import { render } from "./PelangganAddModal.vue?vue&type=template&id=21f55c72&scoped=true"
import script from "./PelangganAddModal.vue?vue&type=script&lang=js"
export * from "./PelangganAddModal.vue?vue&type=script&lang=js"

import "./PelangganAddModal.vue?vue&type=style&index=0&id=21f55c72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21f55c72"

export default script